import type { SVGProps } from "react";

/** Cohere — marque emblématique : trois traits diagonaux dans un cercle (icône seule, sans wordmark). */
export function CohereLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <g stroke="var(--ivory, #F7F2EA)" strokeWidth="1.8" strokeLinecap="round">
        <line x1="7" y1="14" x2="14" y2="7" />
        <line x1="9" y1="17" x2="17" y2="9" />
        <line x1="12" y1="18" x2="18" y2="12" />
      </g>
    </svg>
  );
}
